<script>
    import { scale } from 'svelte/transition';
    import { createEventDispatcher } from 'svelte';
    
    // parmas:
    // type:string -> sets the class of the button: possible classes are: standart, delete
    export let disabled=false, icon=false, width=false, height=false, type='standart';
    
    const dispatch = createEventDispatcher();
    
    const on_keydown = e => {
        e = e || window.event;
        dispatch('key', e);
    }
    
    const handle_click = () => {
        dispatch('click');
    };
        
    </script>
    
    <div class={type} style="width:{width}; height:{height}" >
        {#if icon}
            <svelte:component this={icon} />
        {/if}
        <button class="pointer" {disabled} class:icon on:click|self|stopPropagation={handle_click}>
            <slot>
                <!-- Click me! -->
            </slot>
        </button>
    </div>
    
    <style>
    div {
        position: relative;
        height: var(--button-height);
        width: 240px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: currentColor;
        overflow: hidden;
    }
    
    button {
        height: 100%;
        width: 100%;
        border: 1px solid currentColor;
        transition: border 0.1s;
    }
    
    button:active {
        border: 1px solid var(--color_scheme-contrast_color);
    }
    
    .standart button.icon {
        padding-left: 5px;
        margin-left: var(--button-height);
    }
    
    slot {
        text-transform: uppercase;
    }
    
    .standart {
        max-width: var(--button-max-width);
    }
    
    .delete,
    .edit {
        padding: 5px;
        width: auto;
        height: auto;
        flex: 1;
    }
    
    :global(.standart svg),
    :global(.delete svg),
    :global(.edit svg) {
        pointer-events: none;
        
    }
    
    :global(.delete svg),
    :global(.edit svg) {
        z-index: 10;
        position: absolute;
        width: 50%;
        height: 50%;
    }
    
    .delete button {
        background-color: red;
        border: 2px solid darkred;
    }
    
    .edit button {
        background-color: yellow;
        border: 2px solid orange;
    }
    
    .standart button:hover {
        background-color: var(--theme-button_fill_hover);
    }
    
    .delete button:hover {
        background-color: orange;
    }
    
    .edit button:hover {
        background-color: orange;
    }
    
    .standart button:active {
        background-color: var(--theme-button_fill_active);
    }
    
    .edit button:active {
        background-color: orange;
    }
    
    .delete button:active {
        background-color: orange;
    }
    
    </style>